import { actions, types } from './requests'
export const GETJOBTASKLIST_TYPES = {
    ...types('GETJOBTASKLIST'),
}
export const GETJOBTASKLIST_ACTIONS = {
    ...actions('GETJOBTASKLIST'),
}